import React, {VoidFunctionComponent} from "react";
import {Video} from "@/assets//images/responsive/svg/video";
import {Pdf} from "@/assets//images/responsive/svg/pdf";
import {Link} from "@/assets//images/responsive/svg/link";
import {Download} from "@/assets//images/responsive/svg/download";
import { ProductDocumentList } from "@/models/scope/productSheet/ProductDocumentList";

const DOCUMENT_TYPE = {
    PDF: 'pdf',
    VIDEO: 'video',
};
export const Documentation: VoidFunctionComponent<{
    documentList: ProductDocumentList<string> | null,
    urlVideoAssembly: string,
    urlNotice: string,
    repairabilityIndex: string | null,
    newEnergyClass: string | null
}> = ({documentList, urlVideoAssembly, urlNotice, repairabilityIndex, newEnergyClass}) => {
    const renderDocumentBlock = (label: string, link: string, type: string, index?: number) => {
        return (
            <a
                className='link'
                href={link}
                rel='noopener noreferrer'
                target='_blank'
                key={index}
            >
                <div className='document-block'>
                    {type === DOCUMENT_TYPE.VIDEO ? <Video/> : <Pdf/>}
                    <p className='label'>{label}</p>
                    {type === DOCUMENT_TYPE.VIDEO ? <Link/> : <Download/>}
                </div>
            </a>
        );
    };
    return (
        <div className='documentation'>
            {urlVideoAssembly && renderDocumentBlock(
                'Vidéo de montage',
                urlVideoAssembly,
                DOCUMENT_TYPE.VIDEO
            )}
            {urlNotice && renderDocumentBlock(
                'Télécharger la notice',
                urlNotice,
                DOCUMENT_TYPE.PDF
            )}
            {documentList &&
                Object.keys(documentList)?.map((document, index) =>
                    renderDocumentBlock(
                        document,
                        documentList[document],
                        DOCUMENT_TYPE.PDF,
                        index,
                    ),
                )}
            {(newEnergyClass || repairabilityIndex) &&
                <a
                    className='link'
                    href={"https://media.but.fr/PDF/Loi_AntiGaspillage.pdf"}
                    rel='noopener noreferrer'
                    target='_blank'
                >
                    <div className='document-block'>
                        <Pdf/>
                        <p className='label'>En savoir plus sur la loi anti-gaspillage</p>
                        <Download/>
                    </div>
                </a>
            }
        </div>
    );
};